import { render } from "./ContactUsCN.vue?vue&type=template&id=8b797f74"
import script from "./ContactUsCN.vue?vue&type=script&lang=js"
export * from "./ContactUsCN.vue?vue&type=script&lang=js"

import "./ContactUsCN.vue?vue&type=style&index=0&id=8b797f74&lang=less"

import exportComponent from "/home/data/jenkins/workspace/Pro_TWI_T/Pro_TWI_h5_advantrade-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__